import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'

const CREATE_UPDATE_WORK_EXPERIENCES = gql`
  mutation createOrUpdateWorkExperiences($expertId: String!, $input: [WorkExperienceInput!]!) {
    createOrUpdateWorkExperiences(expertId: $expertId, input: $input) {
      newEntities {
        ... on WorkExperience {
          id
        }
      }
      updatedEntities
    }
  }
`

export default () => useMutation(CREATE_UPDATE_WORK_EXPERIENCES)
